import { RESOLUTION_VALUES } from '@wg/shared';

// Narrow types derived from the shared resolution tuple. Using these avoids
// the `as '128'|'256'|...` / `as 128|256|...` casts that previously guarded
// the Resolution Select in ParamsPanel.
export type Resolution = typeof RESOLUTION_VALUES[number];
export type ResolutionStr = `${Resolution}`;

export const RESOLUTION_OPTIONS: readonly { value: ResolutionStr; label: string }[] =
  RESOLUTION_VALUES.map((v) => ({ value: `${v}` as ResolutionStr, label: `${v}²` }));

export function parseResolution(s: string): Resolution {
  const n = Number(s);
  if (!(RESOLUTION_VALUES as readonly number[]).includes(n)) {
    throw new Error(`Invalid resolution: ${s}`);
  }
  return n as Resolution;
}
